import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import config from '../../config/configuration_keys.json';

const PageBanner = ({ chooseUsSections }) => {
    let header = chooseUsSections[0]?.tittle || 'N/A'
    let description = chooseUsSections[0]?.description || 'N/A'
    let backgroundImage = chooseUsSections[0]?.image || 'N/A';
    const REACT_APP_API_URL = config.REACT_APP_API_URL;

    return (
        <>
            <div
                className='contact_banner'
                style={{
                    backgroundImage: backgroundImage !== 'N/A' ? `url(${REACT_APP_API_URL}/uploads/${backgroundImage})` : '',
                }}
            >
                <Container >
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                            <div className="heading">
                                <h1>{header}</h1>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} className='box-ct-paragraph'>
                            <div className="description">
                                <p>{description}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default PageBanner